/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
export const useControlledValue = ({ defaultValue, value, onValueChange, }, fallbackValue) => {
    const isControlled = value !== undefined;
    const [state, setState] = React.useState(isControlled ? value : defaultValue !== null && defaultValue !== void 0 ? defaultValue : fallbackValue);
    const handleChange = (newValue) => {
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(newValue);
        if (!isControlled)
            setState(newValue);
    };
    return [isControlled ? value : state, handleChange];
};
